import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=208904ea&scoped=true&lang=pug&"
import script from "./Captcha.vue?vue&type=script&lang=js&"
export * from "./Captcha.vue?vue&type=script&lang=js&"
import style0 from "./Captcha.vue?vue&type=style&index=0&id=208904ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208904ea",
  null
  
)

export default component.exports